import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
        error: false,
        user: null,
    },
    mutations: {
        setUser (state, payload) {
            state.user = payload
        },
        setLoading (state, payload) {
            state.loading = payload
        },
        setError (state, payload) {
            state.error = payload
        },
        clearError (state) {
            state.error = null
        }
    },
    actions: {
        userSignup ({commit}, payload) {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then(
                    user => {
                    commit('setLoading', false)
                        const newUser = {
                            id: user.uid,
                            email: user.email,
                            fbKeys: {}
                        }
                        commit('setUser', newUser)
                    }    
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                        console.error(error)
                    }    
                )
        },
        userSignin ({commit}, payload) {
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then(
                    user => {
                        commit('setLoading', true)
                        commit('clearError')
                        const newUser = {
                            id: user.uid,
                            email: user.email,
                            fbKeys: {}
                        }
                        commit('setUser', newUser)
                    }    
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                        console.error(error)
                    }
                )
        },
        autoSignin ({commit}, payload) {
            commit('setUser', {
                id: payload.uid,
                email: payload.email,
                fbKeys: {}
            })
        },
        fetchUserData ({commit, getters}) {
            commit('setLoading', true)
            firebase.database().ref('/users/' + getters.user.id)
                .once('value')
                .then(data => {
                    const dataPairs = data.val()
                    let swappedPairs = {}
                    for (let key in dataPairs) {
                        swappedPairs[dataPairs[key]] = key
                    }
                    const updatedUser = {
                        id: getters.user.id,
                        email: getters.user.email,
                        fbKeys: swappedPairs
                    }
                    commit('setLoading', false)
                    commit('setUser', updatedUser)
                })
                .catch(error => {
                    console.log(error)
                    commit('setLoading', false)
                })
        },
        UserSignout ({commit}) {
            firebase.auth().signOut()
            commit('setUser', null)  
        },
        clearError ({commit}) {
            commit('clearError')
        }
    },
    getters: {
        loading (state) {
            return state.loading
        },
        user (state) {
            return state.user
        },
        error (state) {
            return state.error
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js